import script from "./PhaseAnnouncer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhaseAnnouncer.vue?vue&type=script&setup=true&lang=ts"

import "./PhaseAnnouncer.vue?vue&type=style&index=0&id=36294515&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36294515"]])

export default __exports__